type TReturn = string | URLSearchParams | Record<string, unknown>;

export const normalizeSearchParams = <T extends TReturn>(
	params: Record<string, unknown>,
	format?: 'search' | 'string',
) => {
	const searchParams = new URLSearchParams();

	const entriesParams = Object.entries(params);
	entriesParams.forEach(entry => {
		const [key, val] = entry;

		if (val !== null && val !== undefined && val !== '') {
			searchParams.set(key, String(val));
		} else {
			searchParams.delete(key);
		}
	});

	if (format === 'search') return searchParams as T;
	if (format === 'string') return searchParams.toString() as T;

	return Object.fromEntries(searchParams) as T;
};
